import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";
import UserOnglet from "../../user/UserOnglet";

const HelpTopicModifModePaiement = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Payer une inscription', link: '/topics/paiement/payer-inscription'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Si l'un des modes de paiement de votre compte est incorrect (par exemple, la carte de crédit a expiré), 
              vous pouvez le modifier ou en ajouter un nouveau.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Il n'est pas encore possible d'ajouter et d'enregistrer un mode de paiement sur Wodzone. Cependant, 
                nos développeurs travaillent activement pour intégrer cette fonctionnalité dans les plus brefs délais.
              </p>
              <p className="help-text">
                Mais si c'était possible, la marche à suivre serait celle-ci :
              </p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32" >
                    <p className="help-subtitle-part">Ajouter un mode de paiement sur ordinateur</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Paramètres du compte,</strong> puis sur
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur <strong>Ajouter un mode de paiement.</strong></p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Ajouter un mode de paiement sur navigateur mobile</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyer sur <strong>Paramètres du compte,</strong> puis sur
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyer sur <strong>Ajouter un mode de paiement.</strong></p></li>
                    </ol>
                  </div>
              }
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Là encore, il n'est pas encore possible de supprimer un mode de paiement puisque il n'est pas encore possible
                d'en créer un. Logique, simple, basique.
              </p>
              <p className="help-text">
                Mais si c'était possible, la marche à suivre serait celle-ci :
              </p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32" >
                    <p className="help-subtitle-part">Supprimer un mode de paiement sur ordinateur</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Paramètres du compte,</strong> puis sur
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté du mode de paiement, cliquez sur l'icône représentant 3 points ...</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur <strong>Supprimer.</strong></p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Supprimer un mode de paiement sur navigateur mobile</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyer sur <strong>Paramètres du compte,</strong> puis sur
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté du mode de paiement, appuyer sur l'icône représentant 3 points ...</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyer sur <strong>Supprimer.</strong></p></li>
                    </ol>
                  </div>
              }
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Là encore, il n'est pas encore possible de supprimer un mode de paiement puisque il n'est pas encore possible
                d'en créer un. Logique, simple, basique.
              </p>
              <p className="help-text">
                Mais si c'était possible, la marche à suivre serait celle-ci :
              </p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32" >
                    <p className="help-subtitle-part">Définir un mode de paiement par défaut sur ordinateur</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Paramètres du compte,</strong> puis sur
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté du mode de paiement, cliquez sur l'icône représentant 3 points ...</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur <strong>Définir comme mode de paiement par défaut.</strong></p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Définir un mode de paiement par défaut sur navigateur mobile</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyer sur <strong>Paramètres du compte,</strong> puis sur
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté du mode de paiement, appuyer sur l'icône représentant 3 points ...</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyer sur <strong>Définir comme mode de paiement par défaut.</strong></p></li>
                    </ol>
                  </div>
              }
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicModifModePaiement